import Alien from './alien';
import {createSparkRight,createSparkLeft} from '../../../states/effects';
import RoboRomanceEvent from '../../../states/events/robo_romance';

export default class RoboAlien extends Alien {
    constructor(x, y) {
        super(x, y);
        this.anchor.set(0.5, 1);
        this.shadow.y -= 6;
        this.animations.add('idle', ["alienR_i01.png", "alienR_i02"], 8, true);
        this.animations.add('move', ["alienR_i01.png", "alienR_i02"], 8, true);
        //this.animations.add('attack', ["alienB_a01.png", "alienB_a02.png", "alienB_a03.png", "alienB_a04.png", "alienB_a05.png"], 8, true);
        this.animations.add('die', ["alienR_d01.png", "alienR_d02.png", "alienR_d03.png", "alienR_d04.png", "alienR_d05.png"], 8);
    }

    get corpseFrame() {
        return "alienR_d05.png";
    }

    startAttackAnimation(onLoop) {
        this.animateAttack(() => {
            if (this.walking && this.attacking) {
                onLoop();
                this.startAttackAnimation(onLoop);
            }
        });
    }

    get attackTimeMs() {
        return 1500;
    }

    animateAttack(onEnd) {
        createSparkLeft(this.centerX, this.centerY);
        createSparkRight(this.centerX, this.centerY).animations.currentAnim.onComplete.addOnce(onEnd);
    }

    cancelAttackAnimation() {

    }

    get eatSound() {
        return 'alien-3';
    }

    static get phrases() {
        return {
            pick: [
                "Bzzzt!",
                "Zirk!",
                "Kill!",
                "Exterminate!",
                "SCREEEECH!",
            ],
            land: [
                "Bzt bzt!",
                "Screee!",
                "ZWIRK!",
                "Exterminate!",
                "Kill all humans!",
            ]
        }
    }


    get movingSpeed() {
        return 100;
    }

    static get electronic() {return true;}

    onCollideWithWalking(object) {
        if ((object.constructor.type === 'jenkins' || object.constructor.type === 'madjenkins') && !this.romanced) {
            game.narrator.schedule(RoboRomanceEvent, 0, true);
            this.romanced = true;
        }
    }

    checkDistanceWalking(object) {
        if ((object.constructor.type === 'jenkins' || object.constructor.type === 'madjenkins') && Phaser.Point.distance(this, object) < 20) {
            this.onCollideWithWalking(object);
        }
    }

    onCollideWithObject(object) {
        if (!object.constructor.electronic) return;

        super.onCollideWithObject(object);
    }

    static get label() {return 'killer droid'}
    static get type() { return 'robo-alien'}

     static get description() {
        return "That's not the droid you are looking for.";
    }

}


// WEBPACK FOOTER //
// ./src/objects/items/moveable/robo_alien.js